// material-ui
// import {alpha} from '@mui/material/styles';

// ==============================|| OVERRIDES - DIALOG ||============================== //

export default function Dialog(theme) {
    return {
        MuiDialog: {
            styleOverrides: {
                root: {
                    // '& .MuiBackdrop-root': {
                    //     backgroundColor: alpha('#000', 0.7)
                    // }
                },
                paper: {
                    margin: 1,
                    borderRadius: '12px',
                }
            }
        }
    };
}
